module.exports = __webpack_public_path__ + "static/media/college-3.66040717.jpeg";